import React, { Dispatch, SetStateAction } from "react";
import {
  IAddress,
  ICommitteeMemberInput,
  ICooperativeDetails,
  IDeclaration,
  IDocumentsInput,
  IExecutiveMemberInput,
  IFinancialAuditInput,
  IFinancialIncome,
  IFinancialLoan,
  IFinancialShare,
  IShareMemberInput,
} from "../../exports/interfaces";

const Review = ({
  cooperativeInfo,
  address,
  shareFinancial,
  loanFinancial,
  incomeFinancial,
  auditFinancial,
  committeeCooperative,
  executiveCooperative,
  shareMember,
  documents,
  declaration,
  setCurrentStep,
  scrollToStepper,
  edit,
}: {
  cooperativeInfo: ICooperativeDetails;
  address: IAddress;
  shareFinancial: IFinancialShare;
  loanFinancial: IFinancialLoan;
  incomeFinancial: IFinancialIncome;
  auditFinancial: IFinancialAuditInput;
  committeeCooperative: ICommitteeMemberInput[];
  executiveCooperative: IExecutiveMemberInput[];
  shareMember: IShareMemberInput;
  documents: IDocumentsInput;
  declaration: IDeclaration;
  setCurrentStep: Dispatch<SetStateAction<number>>;
  scrollToStepper: () => void;
  edit?: boolean;
}) => {
  const getStepClass = (status: string) => {
    switch (status) {
      case "Complete":
        return "pill-success";
      case "In-Complete":
        return "pill-warning";
      case "Not Started":
        return "pill-danger";
      default:
        return "bg-secondary-subtle text-secondary";
    }
  };

  const ignoredKeys = [
    "file",
    "fileName",
    "documentUrl",
    "bodFile",
    "bodFileName",
    "bodDocumentUrl",
    "citizenshipFront",
    "citizenshipFrontName",
    "citizenshipFrontUrl",
    "citizenshipBack",
    "citizenshipBackName",
    "citizenshipBackUrl",
  ];

  const isFilled = (obj: any) => {
    if (!obj) return false;

    const mergedFields = [
      "mergedCooperativeName",
      "mergedDateNepali",
      "mergedDateEnglish",
      "mergeReason",
    ];

    return Object.entries(obj).every(([key, value]) => {
      if (
        ignoredKeys.includes(key) ||
        key.endsWith("File") ||
        key.endsWith("FileName") ||
        key.endsWith("DocumentUrl") ||
        key.endsWith("Files") ||
        key.endsWith("FileNames") ||
        key.endsWith("DocumentUrls")
      ) {
        return true;
      }

      // Ignore merged fields unless the status is Merged
      if (
        mergedFields.includes(key) &&
        cooperativeInfo.status?.trim().toLowerCase() !== "merged"
      ) {
        return true;
      }

      // Ignore closed fields unless the status is Deactivate
      // const closedFields = ["closeDateNepali", "closeDateEnglish"];

      // if (
      //   closedFields.includes(key) &&
      //   cooperativeInfo.status?.trim().toLowerCase() !== "deactivate"
      // ) {
      //   return true;
      // }

      // Ignore fields that are not filled
      const ignoreFields = [
        "closeDateNepali",
        "closeDateEnglish",
        "otherMembers",
        "institutionalMembers",
        "otherDepositors",
        "cash",
        "association",
        "districtUnion",
        "bank",
        "externalLoan",
        "taxOthers",
        "localOthers",
        "shareOthersMembers",
        "savingOthersMembers",
        "loanOthersMembers",
      ];
      if (ignoreFields.includes(key)) {
        return true;
      }

      return value !== null && value !== "" && value !== undefined;
    });
  };

  const isTableFilled = (table: any[]) => {
    if (!table || table.length === 0) return false;

    return table.every((item) =>
      Object.entries(item).every(([key, value]) => {
        if (key === "husbandName" && item.maritalStatus === "Single") {
          return true;
        }

        if (
          ignoredKeys.includes(key) ||
          key.endsWith("File") ||
          key.endsWith("FileName") ||
          key.endsWith("DocumentUrl") ||
          key.endsWith("Files") ||
          key.endsWith("FileNames") ||
          key.endsWith("DocumentUrls")
        ) {
          return true;
        }

        return value !== null && value !== "" && value !== undefined;
      }),
    );
  };

  const moveToStep = (step: number) => {
    setCurrentStep(step);
    scrollToStepper();
  };

  const steps = [
    {
      id: 1,
      title: "Cooperative Basic Info",
      status: isFilled(cooperativeInfo) ? "Complete" : "In-Complete",
    },
    {
      id: 2,
      title: "Cooperative Address",
      status: isFilled(address) ? "Complete" : "In-Complete",
    },
    {
      id: 3,
      title: "Cooperative Financial Details",
      status:
        isFilled(shareFinancial) &&
        isFilled(loanFinancial) &&
        isFilled(incomeFinancial) &&
        isFilled(auditFinancial)
          ? "Complete"
          : "In-Complete",
    },
    {
      id: 4,
      title: "Cooperative Committee and Executive Details",
      status:
        isTableFilled(committeeCooperative) &&
        isTableFilled(executiveCooperative)
          ? "Complete"
          : "In-Complete",
    },
    {
      id: 5,
      title: "Cooperative Share Member Details",
      status: isFilled(shareMember) ? "Complete" : "In-Complete",
    },
    {
      id: 6,
      title: "Cooperative Document",
      status: isFilled(documents) ? "Complete" : "In-Complete",
    },
    {
      id: 7,
      title: "Declaration",
      status:
        isFilled(declaration) && declaration.declaration === "true"
          ? "Complete"
          : "In-Complete",
    },
  ];
  return (
    <>
      {steps.map((step, index) => (
        <div
          key={step.id}
          className="dashboard-card mt-2 review-card"
          onClick={() => moveToStep(index)}
        >
          <div className="d-flex align-items-center justify-content-between">
            <h6>
              <span className="step-circle">{step.id}</span> {step.title}
            </h6>
            <span
              className={`badge rounded-pill px-3 py-2 ${getStepClass(
                step.status,
              )}`}
            >
              {step.status}
            </span>
          </div>
        </div>
      ))}
    </>
  );
};

export default Review;
